"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentFieldLogic = void 0;
var percent_fieldtype_1 = require("./percent.fieldtype");
Object.defineProperty(exports, "PercentFieldLogic", { enumerable: true, get: function () { return percent_fieldtype_1.PercentFieldLogic; } });
